import React from "react";
import { getUrlEncodedViewForTab } from "../../../helpers/MyDataHelps/getRootViewForTab";
import { ParticipantTabModel, ProjectStyleConfiguration } from "../../../types/MyDataHelps"
import TabIcon from "../TabIcon/TabIcon";
import "./Tabs.css"

export interface TabsProps {
    colorScheme: "Light" | "Dark"
    selectedTabKey: string
    styles?: ProjectStyleConfiguration
    tabs: ParticipantTabModel[]
    projectID: string
    onTabMouseOver?: (tabKey: string) => void
    preview?: boolean
    responsive?: boolean
    sessionID: string
}

export default function (props: TabsProps) {
    if (!props.tabs || props.tabs.length == 0) {
        return null;
    }

    function getTabWidth() {
        if (props.tabs.length >= 5) {
            return 20;
        }
        return 100 / props.tabs.length;
    }

    let highlightColor = props.styles?.TabBarHighlightColor;
    if (props.styles && props.colorScheme == "Dark") {
        highlightColor = props.styles.DarkModeTabBarHighlightColor;
    }

    return <div className={"tabs" + (props.responsive ? " tabs-responsive" : "")}>
        {props.tabs.map(t =>
            <a onMouseOver={props.onTabMouseOver ? () => props.onTabMouseOver!(t.Key) : () => { }} key={t.Key} href={!props.preview ? `#/${props.projectID}/${t.Key}/${getUrlEncodedViewForTab(t.Type, t.Properties, props.sessionID)}` : undefined}
                className={"tab" + (t.Key == props.selectedTabKey ? " selected" : "")}
                style={{ width: getTabWidth() + "%", color: (highlightColor && t.Key == props.selectedTabKey) ? highlightColor : undefined }}>
                <TabIcon tabTitle={t.Title} systemItem={t.SystemItem} image={t.Image} encodedImage={t.EncodedImage} />
                <span className="tab-title">
                    {t.Title}
                </span>
                {!!t.BadgeNumber && t.BadgeNumber > 0 && <div className="badge">{t.BadgeNumber}</div>}
            </a>
        )}
    </div>
}